/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeProceedingParticipantsRequest
 */
export interface MergeProceedingParticipantsRequest {
    /**
     * 
     * @type {string}
     * @memberof MergeProceedingParticipantsRequest
     */
    destinationId: string;
    /**
     * 
     * @type {string}
     * @memberof MergeProceedingParticipantsRequest
     */
    sourceId: string;
}

/**
 * Check if a given object implements the MergeProceedingParticipantsRequest interface.
 */
export function instanceOfMergeProceedingParticipantsRequest(value: object): value is MergeProceedingParticipantsRequest {
    if (!('destinationId' in value) || value['destinationId'] === undefined) return false;
    if (!('sourceId' in value) || value['sourceId'] === undefined) return false;
    return true;
}

export function MergeProceedingParticipantsRequestFromJSON(json: any): MergeProceedingParticipantsRequest {
    return MergeProceedingParticipantsRequestFromJSONTyped(json, false);
}

export function MergeProceedingParticipantsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeProceedingParticipantsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'destinationId': json['destinationId'],
        'sourceId': json['sourceId'],
    };
}

export function MergeProceedingParticipantsRequestToJSON(json: any): MergeProceedingParticipantsRequest {
    return MergeProceedingParticipantsRequestToJSONTyped(json, false);
}

export function MergeProceedingParticipantsRequestToJSONTyped(value?: MergeProceedingParticipantsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'destinationId': value['destinationId'],
        'sourceId': value['sourceId'],
    };
}

